"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { Button } from "@/components/ui/button";
import { useIsHydrated } from "@/hooks/use-is-hydrated";
import { usePostHogConsent } from "@/hooks/use-posthog-consent";
import { getPostHogProjectKey, setPostHogConsent, type PostHogConsentState } from "@/lib/posthog";
const AUTH_ROUTES = ["/sign-in", "/sign-up", "/waitlist"] as const;
export function CookieConsentBanner() {
  const $ = _c(4);
  const pathname = usePathname();
  const consent = usePostHogConsent();
  const isHydrated = useIsHydrated();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = function updateConsent(nextConsent) {
      setPostHogConsent(nextConsent);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const updateConsent = t0;
  const isAuthRoute = AUTH_ROUTES.some(route => pathname === route || pathname.startsWith(`${route}/`));
  if (!isHydrated || consent !== null || !getPostHogProjectKey() || isAuthRoute) {
    return null;
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <p className="text-muted-foreground text-xs/relaxed">Usamos cookies analíticos para entender o uso da plataforma e melhorar a experiência.{" "}<Link className="text-foreground underline-offset-4 hover:underline" href="/privacy">Política de privacidade</Link></p>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Button onClick={() => updateConsent("rejected")} size="sm" variant="outline">Recusar</Button>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="bg-background fixed inset-x-0 bottom-0 z-50 border-t px-4 py-3"><div className="mx-auto flex max-w-6xl flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">{t1}<div className="flex shrink-0 gap-2">{t2}<Button onClick={() => updateConsent("accepted")} size="sm">Aceitar</Button></div></div></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}